import { DockingViewState } from 'owa-editor-docking-plugin';

const DEFAULT_CARET_MARGIN = 2;

// Get a scrollTop value to make the cursor visible
export default function getScrollTopForCursor(
    dockingViewState: DockingViewState,
    scrollContainerScrollTop: number,
    containerTop: number,
    containerBottom: number,
    cursorTop: number,
    cursorBottom: number,
    caretMargin: number = DEFAULT_CARET_MARGIN
): number {
    const bottomOverflow =
        cursorBottom -
        (containerBottom -
            dockingViewState.bottomDockingHeight -
            dockingViewState.scrollBarHeight) +
        caretMargin;

    // Scroll cursor into view if needed
    if (dockingViewState.isBottomDocking && bottomOverflow > 0) {
        scrollContainerScrollTop += bottomOverflow;
    }

    return scrollContainerScrollTop;
}
